<template>
	<div>
		<app-eye-doc-stepper step="0"></app-eye-doc-stepper>

		<v-container>
			<v-card>
				<v-card-title primary-title>
					<v-row no-gutters>
						<v-col cols="12">
							<v-row align="center" no-gutters>
								<v-col class="expand">
									<div class="title">Appointments</div>
								</v-col>
								<v-col class="shrink">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon v-on="on" @click="filtering = !filtering">
												<v-icon color="primary">{{ filtering ? "mdi-filter" : "mdi-filter-outline" }}</v-icon>
											</v-btn>
										</template>

										<span>Filter Appointments</span>
									</v-tooltip>
								</v-col>
								<v-col class="shrink">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon color="success" v-on="on" @click="showNewAppointment">
												<v-icon color="success">mdi-plus</v-icon>
											</v-btn>
										</template>

										<span>New Appointment</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="12">
							<v-text-field
								v-model="search"
								append-icon="$vuetify.icons.search"
								label="Search (Patient Name, Patient ID, Appointment ID)"
								single-line
								hide-details
								clearable
							></v-text-field>
						</v-col>

						<v-col v-if="filtering" cols="12">
							<v-row dense>
								<v-col cols="12" sm="4">
									<v-label>State</v-label>
									<v-radio-group v-model="filterState">
										<v-radio label="All" value="0"></v-radio>
										<v-radio label="Cancelled" value="1"></v-radio>
										<v-radio label="Patient left" value="2"></v-radio>
										<v-radio label="Waiting" value="3"></v-radio>
										<v-radio label="Confirmed" value="4"></v-radio>
									</v-radio-group>
								</v-col>

								<v-col cols="12" sm="4">
									<v-label>Stage</v-label>
									<v-radio-group v-model="filterStage">
										<v-radio label="All" value="0"></v-radio>
										<v-radio label="Didn't Arrive" value="1"></v-radio>
										<v-radio label="Waiting Room" value="2"></v-radio>
										<v-radio label="Preliminary Examination" value="3"></v-radio>
										<v-radio label="Specialist Examination" value="4"></v-radio>
									</v-radio-group>
								</v-col>

								<v-col class="text-center" cols="12" sm="4">
									<v-label>Date</v-label>
									<v-radio-group v-model="filterSpecificDate">
										<v-radio label="All dates" value="0"></v-radio>
										<v-radio label="Specific day" value="1"></v-radio>
									</v-radio-group>
									<v-dialog
										v-if="filterSpecificDate"
										ref="dialog3"
										v-model="modal3"
										:return-value.sync="filterDate"
										persistent
										width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="filterDate"
												label="Date"
												prepend-icon="mdi-calendar"
												readonly
												:rules="[rules.required]"
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker v-model="filterDate" scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="modal3 = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.dialog3.save(filterDate)">OK</v-btn>
										</v-date-picker>
									</v-dialog>
								</v-col>
								<v-col class="text-center" cols="12">
									<v-btn color="success" class="text-none mx-2 my-2" @click="applyFilter">Apply Filter</v-btn>
									<v-btn
										color="error"
										class="text-none mx-2 my-2"
										:disabled="!filterEnabled"
										@click="clearFilter"
									>
										<template>Remove Filter</template>
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-title>

				<v-card-text class="pa-0 pt-6">
					<v-data-table
						:headers="headers"
						:items="items"
						:loading="loading"
						:search="search"
						multi-sort
						hide-default-footer
					>
						<template v-slot:item.name="{ item }">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<a v-on="on" @click="openProfile(item)">{{ item.name }}</a>
								</template>

								<span>View profile</span>
							</v-tooltip>
						</template>

						<template v-slot:item.attend="{ item }">
							<v-switch v-model="item.attend" hide-details color="primary"></v-switch>
						</template>

						<template v-slot:item.status="{ item }">
							<div
								:class="{'success--text':item.status=='New Appointment','error--text':item.status=='Past Due'}"
							>
								<template>{{ item.status }}</template>
							</div>
						</template>

						<template v-slot:item.stage="{ item }">
							<div>
								<span :class="{'success--text' : item.stageId == 2}">{{ item.stage }}</span>
								<v-tooltip v-if="item.stageId != 3 && item.stageId != 4 && user.UserType == 5" bottom>
									<template v-slot:activator="{ on }">
										<v-icon
											color="primary"
											style="vertical-align: middle"
											:disabled="stagingUp"
											v-on="on"
											@click="nextStage(item)"
											@mouseover="getNextStageLabel(item);"
										>
											<template>mdi-chevron-right</template>
										</v-icon>
									</template>
									<span>Next stage: {{ item.nextStage }}</span>
								</v-tooltip>
							</div>
						</template>

						<template v-slot:item.actions="{ item }">
							<span style="white-space: nowrap;">
								<v-tooltip
									v-if="item.stageId != 1 && item.stageId != 2 && item.stageId != 4 && user.UserType == 4"
									bottom
								>
									<template v-slot:activator="{ on }">
										<v-icon color="primary" v-on="on" @click="goToMedInfo(item.id)">mdi-open-in-new</v-icon>
									</template>

									<span>Check up</span>
								</v-tooltip>

								<v-tooltip v-if="item.stageId != 3 && item.stageId != 4 && user.UserType == 5" bottom>
									<template v-slot:activator="{ on }">
										<v-icon color="secondary" v-on="on" @click="editAppointment(item)">mdi-calendar-edit</v-icon>
									</template>

									<span>Edit</span>
								</v-tooltip>

								<v-tooltip
									v-if="item.stageId != 1 && item.stageId != 2 && item.stageId != 3 && user.UserType == 3"
									bottom
								>
									<template v-slot:activator="{ on }">
										<v-icon color="black" v-on="on" @click="goToGrading(item.id)">mdi-file-document-outline</v-icon>
									</template>

									<span>Grading</span>
								</v-tooltip>

								<v-tooltip
									v-if="item.stageId != 2 && item.stageId != 3 && item.stageId != 4 && user.UserType == 5"
									bottom
								>
									<template v-slot:activator="{ on }">
										<v-icon color="error" v-on="on" @click="deleteAppointment(item)">mdi-delete</v-icon>
									</template>

									<span>Cancel</span>
								</v-tooltip>
							</span>
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions v-if="length">
					<v-row no-gutters>
						<v-col class="text-center" cols="12">
							<v-pagination v-model="page" :length="length" circle color="primary"></v-pagination>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>

			<v-dialog v-model="dialogNewAppointment" persistent max-width="500px">
				<v-card>
					<v-card-title>
						<span class="headline">New Appointment</span>
					</v-card-title>
					<v-card-text v-if="patientName == 'Not found' && rules.nationalId(patientId) == true">
						<v-alert type="info" :value="true" border="top" prominent icon="mdi-account-plus">
							There is no patient with id = {{ patientId }}
							<br />
							<router-link :to="/patient/ + patientId" class="white--text">Click here to add the patient</router-link>
						</v-alert>
					</v-card-text>
					<v-card-text>
						<v-container>
							<v-form v-model="newValid">
								<v-row dense>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="patientId"
											label="Patient ID"
											:rules="[rules.required, rules.nationalId]"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="patientName"
											label="Patient Name"
											disabled
											:loading="patientLoading"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field v-model="clinicId" label="Clinic ID" :rules="[rules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field v-model="clinicName" label="Clinic Name" disabled :loading="clinicLoading"></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-autocomplete
											v-model="docId"
											label="Eye Specialist"
											:items="doctors"
											item-value="id"
											item-text="name"
											:rules="[rules.required]"
										></v-autocomplete>
									</v-col>
									<v-col cols="12" sm="6">
										<v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="date"
													label="Date"
													prepend-icon="mdi-calendar"
													readonly
													:rules="[rules.required]"
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="date" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="modal = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
											</v-date-picker>
										</v-dialog>
									</v-col>
									<v-col cols="12" sm="6">
										<v-dialog
											ref="dialog2"
											v-model="modal2"
											:return-value.sync="time"
											persistent
											width="290px"
										>
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="time"
													label="time"
													prepend-icon="mdi-timer"
													readonly
													:rules="[rules.required]"
													v-on="on"
												></v-text-field>
											</template>
											<v-time-picker v-model="time" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="modal2 = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.dialog2.save(time)">OK</v-btn>
											</v-time-picker>
										</v-dialog>
									</v-col>
									<v-col cols="12">
										<v-select
											v-model="state"
											label="State"
											:items="states"
											item-value="id"
											item-text="name"
											:rules="[rules.required]"
										></v-select>
									</v-col>
								</v-row>
							</v-form>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							:loading="loadingAction"
							@click.native="dialogNewAppointment = false"
						>
							<template>Close</template>
						</v-btn>
						<v-btn
							color="blue darken-1"
							text
							:disabled="!newValid"
							:loading="loadingAction"
							@click.native="submitNewAppointment"
						>
							<template>Save</template>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialog" persistent max-width="500px">
				<v-card>
					<v-card-title>
						<span class="headline">Edit Appointment</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-form v-model="newValid">
								<v-row dense>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="patientId"
											label="Patient ID"
											:rules="[rules.required, rules.nationalId]"
											disabled
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="patientName"
											label="Patient Name"
											disabled
											:loading="patientLoading"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field v-model="clinicId" label="Clinic ID" :rules="[rules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field v-model="clinicName" label="Clinic Name" disabled :loading="clinicLoading"></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-autocomplete
											v-model="docId"
											label="Eye Specialist"
											:items="doctors"
											item-value="id"
											item-text="name"
											:rules="[rules.required]"
										></v-autocomplete>
									</v-col>
									<v-col cols="12" sm="6">
										<v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="date"
													label="Date"
													prepend-icon="mdi-calendar"
													readonly
													:rules="[rules.required]"
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="date" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="modal = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
											</v-date-picker>
										</v-dialog>
									</v-col>
									<v-col cols="12" sm="6">
										<v-dialog
											ref="dialog2"
											v-model="modal2"
											:return-value.sync="time"
											persistent
											width="290px"
										>
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="time"
													label="time"
													prepend-icon="mdi-timer"
													readonly
													:rules="[rules.required]"
													v-on="on"
												></v-text-field>
											</template>
											<v-time-picker v-model="time" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="modal2 = false">Cancel</v-btn>
												<v-btn text color="primary" @click="$refs.dialog2.save(time)">OK</v-btn>
											</v-time-picker>
										</v-dialog>
									</v-col>
									<v-col cols="12">
										<v-select
											v-model="state"
											label="State"
											:items="states"
											item-value="id"
											item-text="name"
											:rules="[rules.required]"
										></v-select>
									</v-col>
								</v-row>
							</v-form>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" text @click.native="dialog = false">Close</v-btn>
						<v-btn
							color="blue darken-1"
							text
							:disabled="!newValid"
							:loading="loadingAction"
							@click.native="updateAppointment"
						>
							<template>Update</template>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="deleteDialog" max-width="500px">
				<v-card>
					<v-card-title>
						<span class="headline">Confirm deletion</span>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="black--text">
						<div class="title">Do you really want to delete this appointment?</div>
						<template v-if="appointment">
							<br />
							Appointment ID: {{ appointment.id }}
							<br />
							Name: {{ appointment.user.FirstName + " " + appointment.user.FatherName + " " + appointment.user.FamilyName }}
							<br />
						</template>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn class="text-none" color="error" @click.native="deleteDialog = false">Cancel</v-btn>
						<v-btn
							class="text-none white--text"
							color="blue darken-1"
							@click.native="confirmDelete(appointment)"
						>
							<template>Confirm</template>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-container>
	</div>
</template>

<script>
const axios = require("axios");
const debounce = require("lodash/debounce");

export default {
	components: {
		"app-eye-doc-stepper": require("@/components/steppers/AppEyeDocStepper.vue")
			.default
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/rules-mixin").default,
		require("@/mixins/router-mixin").default
	],
	data: () => ({
		headers: [
			{
				text: "#",
				align: "left",
				value: "id"
			},
			{
				text: "Patient Name",
				align: "left",
				value: "name"
			},
			{
				text: "Patient ID",
				align: "left",
				value: "patient_id"
			},
			{
				text: "State",
				align: "left",
				value: "state"
			},
			{
				text: "Eye Specialist",
				align: "left",
				value: "eye_specialist"
			},
			{
				text: "Date",
				align: "left",
				value: "date"
			},
			{
				text: "Time",
				align: "left",
				value: "time"
			},
			{
				text: "Stage",
				align: "left",
				value: "stage"
			},
			{
				text: "Actions",
				align: "center",
				value: "actions",
				sortable: false
			}
		],
		items: [],
		loading: true,
		search: "",
		dialog: false,
		modal: false,
		modal2: false,
		date: null,
		time: null,
		patientId: null,
		clinicId: null,
		docId: null,
		dialogNewAppointment: false,
		doctors: [],
		newValid: false,
		page: 1,
		length: null,
		loadingAction: false,
		totalItems: null,
		patientName: null,
		clinicName: null,
		patientLoading: false,
		clinicLoading: false,
		deleteDialog: false,
		appointment: null,
		states: [
			{ id: 3, name: "Waiting for approval" },
			{ id: 4, name: "Approved" }
		],
		state: null,
		stagingUp: false,
		filtering: false,
		filterDate: new Date().toISOString().substring(0, 10),
		filterState: "0",
		filterStage: "0",
		filterSpecificDate: "1",
		modal3: null,
		filterEnabled: false,
		filter: {
			state: "0",
			stage: "0",
			filteringDate: "1",
			date: new Date().toISOString().substring(0, 10)
		}
	}),
	computed: {
		user() {
			return this.$store.state.userInfo;
		}
	},
	watch: {
		search() {
			this.items = [];
			this.loading = true;
			this.triggerPageReload();
		},
		page(newVal) {
			this.items = [];
			this.loading = true;
			this.getFilteredPage(newVal);
		},
		totalItems(newVal) {
			this.$store.dispatch("triggerPushNotification", {
				message: "You got " + newVal + " appointments today"
			});
		},
		patientId(id) {
			this.patientLoading = true;
			this.patientName = "Fetching...";
			this.getPatientName(id);
		},
		clinicId(id) {
			this.clinicLoading = true;
			this.clinicName = "Fetching...";
			this.getClinicName(id);
		}
	},
	created() {
		this.getPatientName = debounce(this.getPatientName, 500);
		this.getClinicName = debounce(this.getClinicName, 500);
		this.getFilteredPage = debounce(this.getFilteredPage, 500);
		this.getPage = debounce(this.getPage, 500);
	},
	mounted() {
		this.fetchData();
		this.checkIfNewAppointment();
	},
	methods: {
		fetchData() {
			this.getFilteredPage(1);
			this.getDoctors();
		},
		getDoctors() {
			const thisVue = this;
			const url = this.BACKEND_URL + "/api/getDoctors";

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.doctors = response.data.map(item => {
							item.name = item.FirstName + " " + item.FamilyName;
							item.id = item.nationalId;
							return item;
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		async getPage(page) {
			var user = await this.user;

			const thisVue = this;
			const url =
				this.BACKEND_URL +
				"/api/todayAppointment/" +
				user.UserType +
				"?page=" +
				page;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.loading = false;
						thisVue.length = response.data.meta.last_page;
						thisVue.totalItems = response.data.meta.total;
						thisVue.items = response.data.data.map(item => {
							item.name =
								item.patient.FirstName +
								" " +
								item.patient.FamilyName;
							item.patient_id = item.patient.nationalId;
							item.time = item.time1;
							item.stateId = item.state;
							item.state = item.state.description;
							item.stageId = item.stage.id;
							item.stage = item.stage.description;
							item.nextStage = "...";
							item.eye_specialist =
								item.doc.FirstName + " " + item.doc.FamilyName;
							return item;
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		applyFilter() {
			this.filterEnabled = true;
			this.filter = {
				state: this.filterState,
				stage: this.filterStage,
				filteringDate: this.filterSpecificDate,
				date: this.filterDate
			};
			this.page = 1;
			this.getFilteredPage(1);
		},
		clearFilter() {
			this.filterEnabled = false;
			this.filter = {
				state: "0",
				stage: "0",
				filteringDate: "1",
				date: new Date().toISOString().substring(0, 10)
			};
			this.page = 1;
			this.getFilteredPage(1);
		},
		async getFilteredPage(page) {
			if (!this.filterEnabled && !this.search) {
				console.log(!this.filterEnabled);
				console.log(!this.search);
				this.getPage(page);
				return;
			}

			// var user = await this.$store.state.userInfo;

			const thisVue = this;
			const url =
				this.BACKEND_URL + "/api/searchFilter" + "?page=" + page;

			var data = {};

			if (this.filterEnabled) {
				data = { ...data, ...this.filter };
			}

			if (this.search) {
				data = { ...data, search: this.search };
			}

			axios
				.post(url, data)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.loading = false;
						thisVue.length = response.data.meta.last_page;
						thisVue.totalItems = response.data.meta.total;
						thisVue.items = response.data.data.map(item => {
							item.name =
								item.patient.FirstName +
								" " +
								item.patient.FamilyName;
							item.patient_id = item.patient.nationalId;
							item.time = item.time1;
							item.stateId = item.state;
							item.state = item.state.description;
							item.stageId = item.stage.id;
							item.stage = item.stage.description;
							item.nextStage = "...";
							item.eye_specialist =
								item.doc.FirstName + " " + item.doc.FamilyName;
							return item;
						});

						console.log(thisVue.items);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		goToCheckUp(appointmentId) {
			window.open("/checkup/" + appointmentId, "_blank");
		},
		goToMedInfo(appointmentId) {
			this.$router.push("/patient-med-info/" + appointmentId);
		},
		goToGrading(appointmentId) {
			this.$router.push("/grading/" + appointmentId);
		},
		submitNewAppointment() {
			if (
				this.patientName == "Fetching..." ||
				this.patientName == "Not found" ||
				this.clinicName == "Fetching..." ||
				this.clinicName == "Not found"
			) {
				return;
			}

			const url = this.BACKEND_URL + "/api/storeAppointment";

			var data = new FormData();
			this.loadingAction = true;

			data.append("patientId", this.patientId);
			data.append("clinicId", this.clinicId);
			data.append("date", this.date);
			data.append("time1", this.time);

			data.append("userId", this.userId);
			data.append("docId", this.docId);
			data.append("state", this.state);
			data.append("stage", this.stage);
			data.append("note", this.note);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.dialogNewAppointment = false;
						thisVue.triggerPageReload();
						thisVue.$store.dispatch("triggerPushNotification", {
							message: "Appointment added"
						});
					}
					thisVue.loadingAction = false;
				})
				.catch(error => {
					this.$store.dispatch("triggerPushNotification", {
						message: error.message
					});
					console.error(error);
					thisVue.loadingAction = false;
				});
		},
		showNewAppointment() {
			var user = this.$store.state.userInfo;

			if (user == null) {
				setTimeout(() => {
					this.showNewAppointment();
				}, 500);

				return;
			}

			this.clinicId = user.Clinic;
			this.userId = user.nationalId;

			this.state = 3;
			this.stage = 1;
			this.note = "";

			this.dialogNewAppointment = true;
		},
		deleteAppointment(appointment) {
			this.appointment = appointment;
			this.deleteDialog = true;
		},
		confirmDelete(appointment) {
			const url =
				this.BACKEND_URL + "/api/cancelAppointment/" + appointment.id;

			var data = new FormData();

			data.append("id", appointment.id);

			let thisVue = this;
			// let config = {};

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						console.log(response);
						var index = thisVue.items.indexOf(appointment);
						if (index != -1) {
							thisVue.items.splice(index, 1);
						}
						thisVue.deleteDialog = false;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		triggerPageReload() {
			if (this.page == 1) {
				this.items = [];
				this.loading = true;
				this.getFilteredPage(1);
			} else {
				this.page = 1;
			}
		},
		checkIfNewAppointment() {
			var id = this.$route.params.patientId;
			if (id) {
				this.patientId = id;
				this.showNewAppointment();
			}
		},
		openProfile(patient) {
			var id = patient.patient_id;
			this.$router.push("/patient-profile/" + id);
		},
		getPatientName(id) {
			const url = this.BACKEND_URL + "/api/getUserById/" + id;

			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						var user = response.data;
						thisVue.patientName =
							user.FirstName + " " + user.FamilyName;
						thisVue.patientLoading = false;
					}
				})
				.catch(error => {
					if (error.response.data == "User not found") {
						thisVue.patientName = "Not found";
						thisVue.patientLoading = false;
					} else {
						console.error(error);
					}
				});
		},
		getClinicName(id) {
			const url = this.BACKEND_URL + "/api/getClinicById/" + id;

			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						var clinic = response.data;
						thisVue.clinicName = clinic.description;
						thisVue.clinicLoading = false;
					}
				})
				.catch(error => {
					if (error.response.data == "Clinic not found") {
						thisVue.clinictName = "Not found";
						thisVue.clinictLoading = false;
					} else {
						console.error(error);
					}
				});
		},
		editAppointment(appointment) {
			var user = this.$store.state.userInfo;

			if (user == null) {
				setTimeout(() => {
					this.editAppointment(appointment);
				}, 500);

				return;
			}

			this.clinicId = appointment.clinic.id;
			this.patientId = appointment.patient.nationalId;
			this.docId = appointment.doc.nationalId;
			this.time = appointment.time1;
			this.date = appointment.date;
			this.state = appointment.stateId;

			this.appointment = appointment;

			this.dialog = true;
		},
		updateAppointment() {
			const url = this.BACKEND_URL + "/api/updateAppointment";

			var data = new FormData();
			this.loadingAction = true;

			data.append("id", this.appointment.id);
			data.append("patientId", this.patientId);
			data.append("clinicId", this.clinicId);
			data.append("date", this.date);
			data.append("time1", this.time);
			data.append("docId", this.docId);
			data.append("state", this.state);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.dialog = false;
						thisVue.triggerPageReload();
						thisVue.$store.dispatch("triggerPushNotification", {
							message: "Appointment changed"
						});
					}
					thisVue.loadingAction = false;
				})
				.catch(error => {
					this.$store.dispatch("triggerPushNotification", {
						message: error.message
					});
					thisVue.loadingAction = false;
				});
		},
		async nextStage(appointment) {
			this.stagingUp = true;
			const url = this.BACKEND_URL + "/api/stageUp/" + appointment.id;

			var data = new FormData();

			data.append("id", appointment.id);

			let thisVue = this;
			// let config = {};

			let nextStage = await this.getNextStage(appointment);

			await axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						appointment.stage = nextStage;
						thisVue.triggerPageReload();
						this.stagingUp = false;
					}
				})
				.catch(error => {
					console.error(error);
					this.stagingUp = false;
				});
		},
		async getNextStage(appointment) {
			const url =
				this.BACKEND_URL + "/api/showNextStage/" + appointment.id;

			let nextStage = null;

			await axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						nextStage = response.data.description;
					}
				})
				.catch(error => {
					console.error(error);
				});

			return nextStage;
		},
		async getNextStageLabel(appointment) {
			if (appointment.nextStage != "...") {
				return appointment.nextStage;
			} else {
				let nextStage = await this.getNextStage(appointment);
				// eslint-disable-next-line require-atomic-updates
				appointment.nextStage = nextStage;
				return appointment.nextStage;
			}
		}
	}
};
</script>

<style scoped>
.v-datatable thead th.column {
	background-color: #fafafa;
	font-weight: bold;
}

.v-input--selection-controls {
	margin-top: initial;
	padding-top: initial;
}

.v-input--selection-controls__input {
	margin-right: initial;
}
</style>
